import { render, staticRenderFns } from "./UnboxReel.vue?vue&type=template&id=087e61d0&scoped=true"
import script from "./UnboxReel.vue?vue&type=script&lang=js"
export * from "./UnboxReel.vue?vue&type=script&lang=js"
import style0 from "./UnboxReel.vue?vue&type=style&index=0&id=087e61d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087e61d0",
  null
  
)

export default component.exports